export const styles = {
  shrinkCell: {
    width: 100,
    maxWidth: 100,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderStyle: 'border-box',
  },
};
